import * as React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';

import { closeModal } from 'src/actions/modals';

import { withCurrentUser } from 'src/components/withCurrentUser';
import ModalContainer from '../modalContainer';
import { PrimaryButton } from 'src/components/button';
import Tooltip from 'src/components/tooltip';
import { modalStyles } from '../styles';
import publishThread from 'shared/graphql/mutations/thread/publishThread';
import editThreadMutation from 'shared/graphql/mutations/thread/editThread';

import { TextArea, Error } from '../../formElements';
import { addToastWithTimeout } from 'src/actions/toasts';
import EmojiPicker from 'src/components/emojiPicker';
import getPresignedPutUrl from 'src/helpers/uploadFile';
import Icon from 'src/components/icon';

import getSnippet from 'shared/clients/draft-js/utils/getSnippet';
import {
  Form,
  Actions,
  PostType,
  Label,
  Edit,
  PostOption,
  PostOptionLabel,
  ExpertsBox,
  ChooseExpert,
  StyledExpertPill,
  PreviewMedia,
  RemovePreviewButton,
  PhotoSizeError,
} from './style';

import SelectGroup from 'src/components/selectGroup';
import Experts from './experts';

const DISCUSSION_PLACEHOLDER = 'What do you want to discuss?';
const QA_PLACEHOLDER = 'What question or problem do you need help with?';
const DATA_TEST_PRE = 'post-modal-';
class CreatePostModal extends React.Component {
  constructor(props) {
    super();
    const { member } = props;
    this.state = {
      title: '',
      discussion: '',
      description: '',
      isDiscussion: member ? false : true,
      isQA: member ? true : false,
      showChooseExpertsModal: false,
      createError: false,
      loading: false,
      selectedExperts: [],
      showEmojiPicker: false,
      mediaPreview: '',
      mediaFile: null,
      mediaType: '',
      mediaName: '',
      photoSizeError: '',
      selectGroupId: '',
      selectGroup: {},
    };
  }

  componentWillMount() {
    const { thread, member } = this.props;
    const selectedExperts = this.state.selectedExperts;
    if (thread) {
      const body = JSON.parse(thread.content.body);
      const media = body.entityMap[0];
      this.setState({
        title: thread.content.title,
        discussion: getSnippet(body),
        isDiscussion: thread.postType === 'DISCUSSION',
        isQA: thread.postType === 'QA',
        mediaPreview: media && media.data.src,
        mediaType: media && media.type,
        mediaName: media && media.data.alt,
      });
      if (thread.experts) {
        this.setState({ selectedExperts: thread.experts });
      }
    }

    if (member && selectedExperts.length === 0) {
      this.setState({ selectedExperts: [...selectedExperts, member.user] });
    }
  }
  componentWillReceiveProps(newProps) {
    const { thread, member } = newProps;
    const selectedExperts = this.state.selectedExperts;
    if (thread) {
      const body = JSON.parse(thread.content.body);
      const media = body.entityMap[0];
      this.setState({
        title: thread.content.title,
        discussion: getSnippet(body),
        isDiscussion: thread.postType === 'DISCUSSION',
        isQA: thread.postType === 'QA',
        mediaPreview: media && media.data.src,
        mediaType: media && media.type,
        mediaName: media && media.data.alt,
      });
      if (thread.experts) {
        this.setState({ selectedExperts: thread.experts });
      }
    }

    if (member && selectedExperts.length === 0) {
      this.setState({ selectedExperts: [...selectedExperts, member.user] });
    }
  }

  close = () => {
    if (this.state.showChooseExpertsModal) {
      this.setState({ showChooseExpertsModal: false });
    } else {
      this.props.dispatch(closeModal());
    }
  };

  confirm = () => {
    this.setState({ showChooseExpertsModal: false });
  };

  create = async e => {
    e.preventDefault();
    this.setState({ loading: true });
    if (!this.state.title || !this.state.discussion) {
      return;
    }
    const { dispatch, groupId, history } = this.props;
    const { title, discussion } = this.state;
    let body = discussion;
    if (this.state.mediaFile) {
      const mediaFile = this.state.mediaFile;
      const fileUrl = await getPresignedPutUrl({
        location: 'post',
        file: mediaFile,
      });
      const uploading = `![${mediaFile.name}](${fileUrl})`;
      if (mediaFile.type === 'video/mp4') {
        body = discussion + ' ' + fileUrl;
      } else {
        body = discussion + uploading;
      }
    }
    const communityId = groupId ? groupId : this.state.selectGroupId;

    const content = {
      title: title.trim(),
      body: body.replace(/@\[([a-z0-9_-]+)\]/g, '@$1'),
    };
    const postType = this.state.isQA ? 'QA' : 'DISCUSSION';
    const userIds = this.state.selectedExperts.map(s => s.id);
    const thread = {
      communityId,
      type: 'TEXT',
      content,
      postType,
      userIds,
      // filesToUpload,
    };

    this.props
      .publishThread(thread)
      .then(({ data }) => {
        dispatch(addToastWithTimeout('neutral', 'Create A New Post'));
        this.setState({
          title: '',
          discussion: '',
          loading: false,
        });
        this.props.dispatch(closeModal());
        if (window.Appcues) {
          window.Appcues.track(`added_${postType}`);
        }

        return history.push(
          `/${data.publishThread.community.slug}/post/${data.publishThread.id}`
        );
      })
      .catch(err => {
        this.setState({
          loading: false,
        });
        this.props.dispatch(addToastWithTimeout('error', err.message));
      });
  };

  edit = async e => {
    e.preventDefault();
    this.setState({ loading: true });
    if (!this.state.title || !this.state.discussion) {
      return;
    }
    const { dispatch, history, thread } = this.props;
    const { title, discussion } = this.state;
    let body = discussion;
    if (this.state.mediaFile) {
      const mediaFile = this.state.mediaFile;
      const fileUrl = await getPresignedPutUrl({
        location: 'post',
        file: mediaFile,
      });
      const uploading = `![${mediaFile.name}](${fileUrl})`;
      if (mediaFile.type === 'video/mp4') {
        body = discussion + ' ' + fileUrl;
      } else {
        body = discussion + uploading;
      }
    } else if (this.state.mediaPreview) {
      if (this.state.mediaType === 'IMAGE') {
        body =
          discussion + `![${this.state.mediaName}](${this.state.mediaPreview})`;
      } else {
        body = discussion + ' ' + this.state.mediaPreview;
      }
    }
    const content = {
      title: title.trim(),
      body: body.replace(/@\[([a-z0-9_-]+)\]/g, '@$1'),
    };
    const userIds = this.state.selectedExperts.map(s => s.id);
    const input = {
      threadId: thread.id,
      content,
      userIds,
    };

    this.props
      .editThread(input)
      .then(({ data: { editThread } }) => {
        this.setState({
          title: '',
          discussion: '',
          loading: false,
        });
        this.props.dispatch(closeModal());
        return history.push(
          `/${editThread.community.slug}/post/${editThread.id}`
        );
      })
      .catch(err => {
        this.setState({
          loading: false,
        });
        dispatch(addToastWithTimeout('error', err.message));
      });
  };
  // TODO check the content
  changeTitle = e => {
    const title = e.target.value;
    this.setState({
      title,
    });
  };

  changeDiscussion = e => {
    const discussion = e.target.value;
    this.setState({
      discussion,
    });
  };

  setDiscussion = () => {
    return this.setState({
      isDiscussion: true,
      isQA: false,
    });
  };

  setQA = () => {
    return this.setState({
      isDiscussion: false,
      isQA: true,
    });
  };
  chooseExpert = () => {
    this.setState({ showChooseExpertsModal: true });
  };
  isAlreadySelected(user) {
    const { selectedExperts } = this.state;
    const isAlreadySelected = selectedExperts.find(
      select => select && select.id === user.id
    );
    if (isAlreadySelected) return true;
    return false;
  }

  handleExperts = experts => {
    this.setState({ selectedExperts: experts });
  };

  removeExpert = e => {
    const { selectedExperts } = this.state;
    this.setState({
      selectedExperts: selectedExperts.filter(
        user => user && user.id !== e.target.id
      ),
    });
  };

  closePicker = () => {
    this.setState({ showEmojiPicker: false });
  };
  onSelectEmoji = ({ native }) => {
    this.closePicker();
    this.setState({
      discussion: `${this.state.discussion}${native}`,
    });
  };
  showPicker = () => {
    this.setState({ showEmojiPicker: true });
  };

  previewMedia = blob => {
    const reader = new FileReader();
    reader.onload = () => {
      this.setState({
        mediaPreview: reader.result.toString(),
        // isSendingMediaMessage: false,
        mediaFile: blob,
      });
    };
    if (blob) {
      reader.readAsDataURL(blob);
    }
  };

  renderLocation(user) {
    let location = null;
    if (user.city && user.country) {
      location = `in ${user.city}, ${user.country}`;
    } else if (user.city) {
      location = `in ${user.city}`;
    } else if (user.country) {
      location = `in ${user.country}`;
    }
    return location;
  }

  isNull(data) {
    if (data && data.trim().length === 0) {
      return true;
    }
    if (!data) return true;
    return false;
  }

  canCreate() {
    const { groupId } = this.props;
    const { title, discussion } = this.state;
    if (
      this.isNull(title) ||
      this.isNull(discussion) ||
      !(groupId || this.state.selectGroupId)
    ) {
      return true;
    }
    return false;
  }
  chooseGroup = group => {
    this.setState({
      selectGroupId: group.value,
      selectedExperts: [],
      selectGroup: group,
    });
  };
  renderChooseExperts() {
    const { groupId } = this.props;

    const { selectedExperts } = this.state;

    return (
      <Experts
        id={groupId ? groupId : this.state.selectGroupId}
        selectedExperts={selectedExperts}
        first="20"
        filter={{ isExpert: true }}
        confirm={this.confirm}
        handleExperts={this.handleExperts}
      />
    );
  }

  renderCreatePost() {
    const { edit } = this.props;
    const {
      title,
      discussion,
      isDiscussion,
      isQA,
      createError,
      loading,
      selectedExperts,
    } = this.state;
    return (
      <ModalContainer
        title={edit ? 'Edit post' : 'Create a Post'}
        closeModal={this.close}
      >
        <Form>
          <TextArea
            id="title"
            defaultValue={title}
            placeholder="Give your post a title to tell others what you want to discuss."
            onChange={this.changeTitle}
            testId={`${DATA_TEST_PRE}change-title`}
          >
            Title
          </TextArea>
          <TextArea
            id="discussion"
            defaultValue={discussion}
            placeholder={isQA ? QA_PLACEHOLDER : DISCUSSION_PLACEHOLDER}
            onChange={this.changeDiscussion}
            showAction={true}
            // showEmojiPicker={this.showPicker}
            previewMedia={this.previewMedia}
            mediaError={err => {
              this.setState({ photoSizeError: err });
            }}
            testId={`${DATA_TEST_PRE}change-discussion`}
          >
            {isQA ? 'Q&A' : 'Discussion'}
          </TextArea>
          {this.state.photoSizeError && (
            <PhotoSizeError>
              <p>{this.state.photoSizeError}</p>
              <Icon
                onClick={() => this.setState({ photoSizeError: '' })}
                glyph="view-close"
                size={16}
                color={'warn.default'}
                data-testid={`${DATA_TEST_PRE}close-modal`}
              />
            </PhotoSizeError>
          )}
          {this.state.mediaPreview && (
            <PreviewMedia>
              <img
                src={this.state.mediaPreview}
                alt=""
                style={{ height: '100%' }}
              />
              <RemovePreviewButton
                onClick={() => this.setState({ mediaPreview: '' })}
                data-testid={`${DATA_TEST_PRE}remove-img`}
              >
                <Icon glyph="view-close-small" size={'16'} />
              </RemovePreviewButton>
            </PreviewMedia>
          )}

          {this.props.groupId ? null : (
            <div>
              <Label>Select a group</Label>
              <SelectGroup
                currentUser={this.props.currentUser}
                chooseGroup={this.chooseGroup}
                selectGroupId={this.state.selectGroupId}
                selectGroup={this.state.selectGroup}
                data-testid={`${DATA_TEST_PRE}select-group`}
              />
            </div>
          )}

          {this.props.groupId || this.state.selectGroupId ? (
            <div>
              <Label>Post type</Label>
              <PostType>
                <PostOption selected={true}>
                  <PostOptionLabel>
                    <input
                      type="radio"
                      value="discussion"
                      checked={isDiscussion}
                      data-cy="community-public-selector-input"
                      onChange={this.setDiscussion}
                      disabled={edit}
                      data-testid={`${DATA_TEST_PRE}set-discussion-type`}
                    />
                    Discussion
                  </PostOptionLabel>
                </PostOption>
                <PostOption selected={false}>
                  <PostOptionLabel>
                    <input
                      type="radio"
                      value="QA"
                      data-cy="community-public-selector-input"
                      checked={isQA}
                      onChange={this.setQA}
                      disabled={edit}
                      data-testid={`${DATA_TEST_PRE}set-qa-type`}
                    />
                    Q&amp;A
                  </PostOptionLabel>
                </PostOption>
              </PostType>
              {isQA ? (
                selectedExperts.length > 0 ? (
                  <div>
                    <Label>
                      <span>
                        Add experts who you'd like to answer your question
                      </span>{' '}
                      <Edit
                        onClick={this.chooseExpert}
                        data-testid={`${DATA_TEST_PRE}edit-expert`}
                      >
                        Edit
                      </Edit>
                    </Label>
                    <ExpertsBox>
                      {selectedExperts.map(
                        user =>
                          user && (
                            <Tooltip key={user.id} content={'Delete'}>
                              <StyledExpertPill
                                id={user.id}
                                key={user.id}
                                onClick={this.removeExpert}
                                data-testid={`${DATA_TEST_PRE}remove-expert`}
                              >
                                {user.firstName && user.lastName
                                  ? `${user.firstName} ${user.lastName}`
                                  : user.name}
                              </StyledExpertPill>
                            </Tooltip>
                          )
                      )}
                    </ExpertsBox>
                  </div>
                ) : (
                  <div>
                    <Label>
                      Choose which of our experts you'd like to answer your
                      question
                    </Label>
                    <ExpertsBox>
                      <ChooseExpert
                        onClick={this.chooseExpert}
                        data-testid={`${DATA_TEST_PRE}choose-expert`}
                      >
                        Click here to choose
                      </ChooseExpert>
                    </ExpertsBox>
                  </div>
                )
              ) : null}
            </div>
          ) : null}
          <Actions>
            {edit ? (
              <PrimaryButton
                disabled={this.canCreate()}
                isLoading={loading}
                onClick={this.edit}
                data-testid={`${DATA_TEST_PRE}update-post`}
              >
                {loading ? 'Updating...' : 'UPDATE'}
              </PrimaryButton>
            ) : (
              <PrimaryButton
                disabled={this.canCreate()}
                isLoading={loading}
                onClick={this.create}
                data-testid={`${DATA_TEST_PRE}create-post`}
              >
                {loading ? 'Creating...' : 'CREATE'}
              </PrimaryButton>
            )}
          </Actions>

          {createError && (
            <Error>
              Please fix any errors above before creating this post.
            </Error>
          )}
          {this.state.showEmojiPicker ? (
            <EmojiPicker
              onSelectEmoji={this.onSelectEmoji}
              closePicker={this.closePicker}
            />
          ) : null}
        </Form>
      </ModalContainer>
    );
  }
  render() {
    const { isOpen } = this.props;
    const { showChooseExpertsModal } = this.state;
    const styles = modalStyles(620);

    return (
      <Modal
        /* TODO(@mxstbr): Fix this */
        ariaHideApp={false}
        isOpen={isOpen}
        onRequestClose={this.close}
        shouldCloseOnOverlayClick={true}
        style={styles}
        closeTimeoutMS={330}
      >
        {showChooseExpertsModal
          ? this.renderChooseExperts()
          : this.renderCreatePost()}
      </Modal>
    );
  }
}

const map = state => ({
  isOpen: state.modals.isOpen,
});
export default compose(
  // $FlowIssue
  connect(map),
  publishThread,
  editThreadMutation,
  withCurrentUser,
  withRouter
)(CreatePostModal);
